<template>
  <LegalDocShell
    title="笔芯科研 用户服务协议"
    crumb-label="服务条款"
    :nav-items="navItems"
  >
    <template #intro>
      欢迎使用笔芯科研（bixinpaper.com）。本协议由您与笔芯科研平台运营方共同订立，具有合同效力。请您在注册或使用服务前仔细阅读。
    </template>

    <section
      v-for="(section, index) in sections"
      :id="'terms-section-' + index"
      :key="section.title"
      class="legal-block"
    >
      <h2>{{ section.title }}</h2>
      <p v-for="(para, idx) in section.paragraphs" :key="idx">{{ para }}</p>
    </section>
  </LegalDocShell>
</template>

<script>
import LegalDocShell from '@/components/legal/LegalDocShell.vue'

export default {
  name: 'TermsView',
  components: { LegalDocShell },
  computed: {
    navItems() {
      return this.sections.map((section, index) => ({
        id: 'terms-section-' + index,
        label: section.title
      }))
    }
  },
  data() {
    return {
      sections: [
        {
          title: '一、总则',
          paragraphs: [
            '1.1 笔芯科研 网站及相关在线服务的所有权、运营权归平台运营方所有。',
            '1.2 您完成微信登录或首次使用本平台，即视为已阅读并同意本协议。若您不同意本协议任何内容，请停止使用本平台。',
            '1.3 平台有权根据业务需要及法律法规变化修订本协议。修订内容将在网站公布，公布后继续使用服务视为接受修订后的协议。'
          ]
        },
        {
          title: '二、账号注册与使用',
          paragraphs: [
            '2.1 您应具备完全民事行为能力。若您为未成年人，应在监护人指导下使用本平台。',
            '2.2 本平台采用微信登录方式。您应妥善保管与微信账号相关的安全信息，因您自身原因导致的账号风险或损失，由您自行承担。',
            '2.3 首次登录将自动创建平台账号并初始化字数点数账户。您应保证所使用微信账号的合法性与真实性。',
            '2.4 如发现账号被盗用或存在异常，请及时通过页脚联系方式与我们沟通处理。'
          ]
        },
        {
          title: '三、服务内容',
          paragraphs: [
            '3.1 笔芯科研 面向文档与文本场景，提供降重复率、降AIGC率、双降、AIGC 检测、文献检索、PPT 辅助、Word 瘦身、图片处理等在线工具（具体以页面上线功能为准）。',
            '3.2 服务按字数点数计费，不同功能消耗倍率以平台公示为准。充值、赠送及活动规则以页面说明及后台记录为准。',
            '3.3 您有权在登录后查看账户余额、处理记录及邀请相关信息，并按平台规则使用各项功能。'
          ]
        },
        {
          title: '四、使用规范',
          paragraphs: [
            '4.1 您应遵守中华人民共和国法律法规及学术诚信要求，不得利用本平台从事违法违规活动。',
            '4.2 不得上传、生成或传播含有以下内容的信息：危害国家安全、破坏社会稳定、侵犯他人权益、淫秽色情、暴力恐怖、虚假信息，以及其他法律禁止的内容。',
            '4.3 您对提交至平台的文本内容应拥有合法权利或已获得必要授权。因内容侵权引发的纠纷，由您自行承担责任。',
            '4.4 本平台提供的AI辅助能力仅用于学习、写作参考与效率提升。您应独立判断生成结果，并遵守所在学校、期刊或机构关于AIGC使用的规定。不得将平台输出直接作为最终提交的科研文章、报告或发表稿件而不经人工审核与改写。',
            '4.5 因违规使用、误用或超出合理用途使用平台功能造成的损失，由您自行承担。'
          ]
        },
        {
          title: '五、隐私与数据',
          paragraphs: [
            '5.1 我们重视用户隐私，具体信息收集与使用规则请参见《隐私政策》。',
            '5.2 为提供服务，您提交的文本会在处理过程中被系统读取，用于完成您所选择的功能。请勿上传含有敏感个人信息的无关内容。',
            '5.3 在法律法规要求或经您授权的情况下，我们可能依法披露相关信息。'
          ]
        },
        {
          title: '六、知识产权',
          paragraphs: [
            '6.1 笔芯科研 网站界面、标识、文案及技术实现等知识产权归平台运营方或相关权利人所有，未经许可不得擅自复制、传播或用于商业用途。',
            '6.2 您保留对原始上传内容的所有权，但授予平台在处理所必需范围内的使用权。',
            '6.3 未经书面许可，不得将平台页面、接口或数据用于爬虫、镜像或竞争性服务。'
          ]
        },
        {
          title: '七、免责声明',
          paragraphs: [
            '7.1 互联网服务存在不可抗力、网络故障、第三方服务异常等风险，平台将尽力保障服务稳定，但不保证服务不间断或完全无错误。',
            '7.2 对于 AI 生成内容的准确性、完整性及适用性，平台不作明示或暗示保证。您应自行核实并承担使用后果。',
            '7.3 因不可抗力、政策变化、系统维护或第三方原因导致的服务中断或数据损失，平台在法律允许范围内免除相应责任。',
            '7.4 平台有权在必要时暂停、变更或终止部分功能，并将通过合理方式通知用户。'
          ]
        },
        {
          title: '八、争议解决',
          paragraphs: [
            '8.1 本协议的订立、执行与解释适用中华人民共和国法律。',
            '8.2 因本协议产生的争议，双方应友好协商；协商不成的，提交平台运营方所在地有管辖权的人民法院诉讼解决。',
            '8.3 本协议部分条款无效不影响其余条款的效力。'
          ]
        }
      ]
    }
  }
}
</script>
